import gql from 'graphql-tag'

export default gql`
query getActionGroups {
	cashAssist {
		getAppConfigAdditional {
			productActionGroups
		}
	}
}`
